// extracted by mini-css-extract-plugin
module.exports = {"installation-popup":"FeePopup_installation-popup__j7WiI"};